function NewUserRegistrationRequestWrapperMeedyVO(firstName, lastName, email, phone, pwz, idAcademicTitle, idMainSpecialization, clinic) {

    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.phone = phone;
    this.pwz = pwz;
    this.idAcademicTitle = idAcademicTitle;
    this.idMainSpecialization = idMainSpecialization;
    this.clinic = clinic;

    var _typeContext = {
        clinic: ClinicVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
